import FooterAccordion from "./FooterAccordion"
import FooterDesktop from "./FooterDesktop"

export default function Footer() {
  return (
    <div>
      {/* Desktop Footer: Visible on lg-screens and larger */}
      <div className="hidden lg:block">
        <FooterDesktop />
      </div>

      {/* Accordion Footer: Visible on small screens */}
      <div className="block lg:hidden">
        <FooterAccordion />
      </div>
    </div>
  );
}
